import { addValidationRule } from '@jumpcloud/ui-components';
import { extend } from 'vee-validate3';
import { required } from 'vee-validate3/dist/rules';

import GroupsConstants from 'client/util/Constants/GroupsConstants';
import isURL from 'validator/lib/isURL';

const spaces = /\s+/g;

const customRules = [
  {
    rule: 'duoApiHostValidation',
    ruleConfig: {
      validate: (value = '') => isURL(value) && !value.includes('://'),
      message: 'The API Hostname must be a valid Duo domain.',
    },
  },
  {
    rule: 'noAdminEmailLink',
    ruleConfig: {
      validate: value => !value.replace(spaces, '').includes('#{admin_email_link}'),
      message: "Admin email link can't be used in this field.",
    },
  },
  {
    rule: 'noTokens',
    ruleConfig: {
      validate: value => {
        const tokenRegex = /#{(.*?)}/g;
        return !value.match(tokenRegex);
      },
      message: 'No tokens allowed in this field.',
    },
  },
  {
    rule: 'passwordConfirmation',
    ruleConfig: {
      params: ['target'],
      validate: (value, { target }) => value === target,
      message: 'Password confirmation does not match',
    },
  },
  {
    rule: 'maximumExemptions',
    ruleConfig: {
      validate: value => value.length <= GroupsConstants.membershipSuggestions.maxExemptions,
    },
  },
  {
    rule: 'isValidQuery',
    ruleConfig: {
      validate: value => {
        if (value[0] === '?') {
          return false;
        }

        try {
          const query = new URLSearchParams(value);
          const values = Array.from(query.values());
          // Check that they actually entered somthing meaningful
          return values.filter(val => Boolean(val)).length > 0;
        } catch {
          return false;
        }
      },
    },
  },
  {
    rule: 'unmanagedDeviceCondition',
    ruleConfig: {
      validate: (value, { hasDiskEncryption, inclusionAll }) => {
        // throw validation when device is 'unmanaged'
        // and disk encryption selected and inlusion is 'all'
        const isInvalid = (
          value === 'exclude'
          && JSON.parse(hasDiskEncryption)
          && JSON.parse(inclusionAll)
        );

        return !isInvalid;
      },
      params: ['hasDiskEncryption', 'inclusionAll'],
      message: 'Unmanaged devices are not compatible with device posture conditions',
    },
  },
  {
    rule: 'required',
    ruleConfig: {
      ...required,
      message: fieldName => {
        const placeholder = '{field}'; // default when fieldName is not passed to ValidationProvider
        return fieldName === placeholder ? 'Required' : `${fieldName} is required`;
      },
    },
  },
];

customRules.forEach(customRule => {
  extend(customRule.rule, customRule.ruleConfig);
  addValidationRule(customRule.rule, customRule.ruleConfig);
});
